import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { useEffect } from "react";
import { TourKey } from "./tourKeys";
import { finishTour, nextStep, prevStep, startTour } from "slices/tour/reducer";
import { TOUR_CONFIG } from "./tourConfig";
import { finishedTourApi } from "helpers/ApiManager";

export function useScreenTour(
  key: TourKey,
  options?: {
    condition?: boolean;
    onExtraClose?: () => void;
    onExtraNext?: () => void;
    onExtraPrev?: () => void;
  }
) {
  const dispatch = useAppDispatch();

  const tours = useAppSelector((state) => state.tours);

  const tour = useAppSelector((state) => state.tours[key]);
  const hydrated = useAppSelector((state) => state.tours.hydrated);

  const canStart =
    hydrated &&
    (options?.condition !== undefined
      ? options.condition && !tour?.isFinished
      : !tour?.isFinished);

  useEffect(() => {
    if (canStart) {
      dispatch(startTour(key));
    }
  }, [canStart, dispatch, key]);

  return {
    open: tour.isRunning,
    steps: TOUR_CONFIG[key],
    currentStep: tour.currentStep - 1,
    key: key,

    onClose: async () => {
      dispatch(finishTour(key));
      options?.onExtraClose?.();
      try {
        console.log("tours[key].isDBfinished)", tours[key].isDBfinished);
        if (tours[key].isDBfinished) {
          return;
        }
        await finishedTourApi(key, tours, "web");
      } catch (error) {
        console.log(error);
      }
    },

    onNext: () => {
      options?.onExtraNext?.();
      if (key === "quote") {
        setTimeout(() => {
          dispatch(nextStep(key));
        }, 600);
        return;
      }
      dispatch(nextStep(key));
    },

    onPrev: () => {
      options?.onExtraPrev?.();
      dispatch(prevStep(key));
    },
  };
}
